import React, { useState, useEffect } from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import Main from './main';

export default function RootRouter() {
    const [basename, setBasename] = useState("lsvc");

    useEffect(() => {
        let basename = location.pathname.match(/^\/[^\/]*/g)[0]
        //location.pathname.match(/[\/][\w]*/)[0]
        if(basename!=="/"){
            setBasename(basename)
        }
    });

    return <Router basename={basename}>
        <Switch>
            <Route path="/" component={Main}/>
            {/*<Route path="/lsvc" component={Main}/>*/}
        </Switch>
    </Router>
}
